import { Step, Stepper } from "../../../components/ui/stepper";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";
import Step4 from "./components/Step4";
import Spin from "../../../components/Spin";
import { useState } from "react";

const steps = [
  { label: "Step 1" },
  { label: "Step 2" },
  { label: "Step 3" },
  { label: "Step 4" },
];

export default function TwoFactorRegister() {
  const [loading, setLoading] = useState(false);
  const [backupEmail, setBackupEmail] = useState("");

  return (
    <>
      {loading && <Spin full={true} />}

      <div className="flex items-center w-full h-screen justify-center">
        <div className="rounded-lg bg-primary-foreground w-fit h-fit">
          <div className="flex justify-between items-stretch min-w-[600px] max-w-[600px] min-h-[500px] flex-col gap-4 p-7 pb-2">
            <Stepper
              initialStep={0}
              steps={steps}
              onClickStep={(step, setStep) => {
                // setStep(step);
              }}
            >
              {steps.map((stepProps, index) => {
                return (
                  <Step key={stepProps.label} {...stepProps}>
                    <div className="h-auto flex flex-1 items-center justify-center my-2 p-3 text-primary rounded-md">
                      {index + 1 === 1 ? (
                        <Step1 loading={loading} setLoading={setLoading} />
                      ) : index + 1 === 2 ? (
                        <Step2
                          verifyUrl={"google-2fa-verify"}
                          setLoading={setLoading}
                        />
                      ) : index + 1 === 3 ? (
                        <Step3
                          backupEmail={backupEmail}
                          setBackupEmail={setBackupEmail}
                          setLoading={setLoading}
                        />
                      ) : (
                        <Step4
                          backupEmail={backupEmail}
                          verifyUrl={"verify-backup-email"}
                          setLoading={setLoading}
                        />
                      )}
                    </div>
                  </Step>
                );
              })}
              {/* <Footer /> */}
            </Stepper>
          </div>
        </div>
      </div>
    </>
  );
}

// const Footer = () => {
//   const {
//     nextStep,
//     prevStep,
//     resetSteps,
//     isDisabledStep,
//     hasCompletedAllSteps,
//     isLastStep,
//     isOptionalStep,
//   } = useStepper();
//   return (
//     <>
//       {hasCompletedAllSteps && (
//         <div className="h-40 flex items-center justify-center my-2 border bg-secondary text-primary rounded-md">
//           <h1 className="text-xl">Woohoo! All steps completed! 🎉</h1>
//         </div>
//       )}
//       <div className="w-full flex justify-end gap-2">
//         {hasCompletedAllSteps ? (
//           <Button size="sm" onClick={resetSteps}>
//             Reset
//           </Button>
//         ) : (
//           <>
//             <Button
//               disabled={isDisabledStep}
//               onClick={prevStep}
//               size="sm"
//               variant="secondary"
//             >
//               Prev
//             </Button>
//             <Button size="sm" onClick={nextStep}>
//               {isLastStep ? "Finish" : isOptionalStep ? "Skip" : "Next"}
//             </Button>
//           </>
//         )}
//       </div>
//     </>
//   );
// };
